import * as actionTypes from 'containers/Portfolio/PageHeader/action-types';
import { BrandType } from 'utils/types';
import ArraysUtils from 'utils/arrays';

export const applyChanges = (selectedBrands: Array<string>) => ({
  type: actionTypes.CHANGES_APPLY,
  payload: selectedBrands
});

export const initializePortfolioBrands = (brands: Array<BrandType>) => ({
  type: actionTypes.PORTFOLIO_BRANDS_INITIALIZE,
  payload: { brands, selectedBrands: brands.map((brand: BrandType) => brand.id) }
});

export const openModal = (selectedBrands: Array<string>) => ({
  type: actionTypes.MODAL_OPEN,
  payload: selectedBrands
});

export const openBrandPickerModal = (selectedBrands: Array<string>) => ({
  type: actionTypes.BRAND_PICKER_MODAL_OPEN,
  payload: selectedBrands
});

export const selectBrand = (
  id: string,
  brands: Array<BrandType>,
  selectedBrands: Array<string>
) => {
  if (id === 'all') {
    return setTransientSelectedBrands(brands.map(brand => brand.id));
  } else if (selectedBrands.length > 0 && selectedBrands.length === brands.length) {
    // Currently all brands select, so make the selected one the only one
    return setTransientSelectedBrands([id]);
  } else {
    const newSelectedBrands = ArraysUtils.addOrRemove(id, selectedBrands);
    if (newSelectedBrands.length === 0) {
      return setTransientSelectedBrands(brands.map(brand => brand.id));
    }
    return setTransientSelectedBrands(newSelectedBrands);
  }
};

export const setSelectedBrands = (ids: Array<string>) => ({
  type: actionTypes.SELECTED_BRANDS_SET,
  payload: ids
});

export const setShowBrandFilterModal = (value: boolean) => ({
  type: actionTypes.BRANDS_FILTER_MODAL_SHOW_SET,
  payload: value
});

export const setShowBrandPickerModal = (value: boolean) => ({
  type: actionTypes.BRANDS_PICKER_MODAL_SHOW_SET,
  payload: value
});

export const setTransientSelectedBrands = (ids: Array<string>) => ({
  type: actionTypes.SELECTED_TRANSIENT_BRANDS_SET,
  payload: ids
});
